module.exports = __webpack_public_path__ + "static/media/CTLA_1-204w.75f56340.webp";